export default __webpack_public_path__ + "static/media/section2.cbdd811d.jpg";